import { ItemIcon, Type } from "@similarweb/ui-components";

import { MAX_DOMAIN_LENGTH } from "app/pages/activation/components/RankWidget/config";

import * as SC from "./styles";

type DomainSchema = {
    imgUrl: string;
    name: string;
    dataAutomation?: string;
};

export const Domain = ({ imgUrl, name, dataAutomation }: DomainSchema) => {
    const truncatedName = name.length > MAX_DOMAIN_LENGTH ? `${name.slice(0, MAX_DOMAIN_LENGTH)}...` : name;

    return (
        <SC.HeaderItemContainer data-automation={dataAutomation}>
            <ItemIcon
                iconType={Type.Website}
                iconSrc={imgUrl}
            />
            <SC.HeaderItemText>{truncatedName}</SC.HeaderItemText>
        </SC.HeaderItemContainer>
    );
};
